export default __webpack_public_path__ + "static/media/white_profile_icon.e3cff009.svg";